define(
  'classes/paginator',['underscore', 'jquery'],
  function(_, $) {

    var Paginator = function(options) {
      if (typeof options.total == 'undefined') {
        throw new Exception('No end page in pagination');
      }
      var _options = _.extend({
          url: window.location.href,
          page: 1,
          per_page: 10,
          query: '',
          mobile: $.isMobileSite()
        }
        , options
      );
      _.extend(this, _options);

      this._parseQuery();

      this._setStartEnd();

    }

    _.extend(Paginator.prototype, {

      getURLForPagination: function(page) {
        var redirect_url = this.url.replace(/page=\d+&?/, '').replace(/removed=\d+&?/, '').replace(/&$/, ''),
            url_info = this.parseUrl(redirect_url),
            url = url_info.path,
            separator;

        if (page != 1) {
          url += '?page=' + page;
          separator = '&';
        }
        else {
          separator = '?';
        }

        if (this.query.length) {
          url += separator + this.query;
        }

        return url;

      },

      getPaginationArray: function() {

        var pages = {
              'first_page': {},
              'pages': [],
              'last_page': {}
            },
            current_page = this.page,
            start_page = current_page - 3,
            end_page = current_page + 3,
            max_pages = Math.ceil(this.total / this.per_page),
            add_extra_to_right = 0,
            add_extra_to_left = 0,
            curr_last_page = 0;

        if (start_page <= 0) {
          add_extra_to_right = (start_page * -1) + 2;
        }

        if (end_page > max_pages) {
          add_extra_to_left = end_page - max_pages;
        }

        // handles the first element
        if (start_page > 2) {
          pages['first_page'] = {
            page: 1,
            url: this.getURLForPagination(1)
          };
        }
        else if (start_page == 2) {
          pages['pages'].push({
            page: 1,
            url: this.getURLForPagination(1)
          });
        }

        //handles the current page +/- 3
        for (var i = current_page - 3; i <= current_page + 3; i++) {
          if (i > 0 && i <= max_pages) {
            pages['pages'].push({
              page: i,
              url: this.getURLForPagination(i)
            });
            curr_last_page = i;
          }
        }

        if (add_extra_to_right) {
          for (var i = curr_last_page; i < curr_last_page + add_extra_to_right; i++) {
            if (i > 0 && i <= max_pages) {
              pages['pages'].push({
                page: i,
                url: this.getURLForPagination(i)
              });
            }
          }
        }

        if (add_extra_to_left) {
          for (var i = current_page - 4; i > current_page - 4 - add_extra_to_left; i--) {
            if (i > 0) {
              pages['pages'].push({
                page: i,
                url: this.getURLForPagination(i)
              });
            }
          }
        }

        // handle the last element of the page
        if (max_pages > end_page && typeof pages['pages'][max_pages] == 'undefined') {
          pages['last_page'] = {
            page: max_pages,
            url: this.getURLForPagination(max_pages)
          };
        }

        pages['pages'] = _.chain(pages['pages'])
          .sortBy('page')
          .uniq(true, function (elem) { return elem.page; })
          .value();

        return pages;

      },

      parseUrl: function(str) {
        //      original by: Steven Levithan (http://blog.stevenlevithan.com)
        // reimplemented by: Brett Zamir (http://brett-zamir.me)

        var key = ['source', 'scheme', 'authority', 'userInfo', 'user', 'pass', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'fragment'];
        var parser = /^(?:([^:\/?#]+):)?(?:\/\/()(?:(?:()(?:([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?))?()(?:(()(?:(?:[^?#\/]*\/)*)()(?:[^?#]*))(?:\?([^#]*))?(?:#(.*))?)/;

        var m = parser.exec(str);
        var uri = {};
        var i = 14;

        while (i--) {
          if (m[i]) {
            uri[key[i]] = m[i];
          }
        }

        delete uri.source;
        return uri;
      },

      getPage: function () {
        return this.page;
      },

      setPage: function (page) {
        this.page = page;
        this._setStartEnd();
      },

      _parseQuery: function() {
        var redirect_url = this.url.replace(/page=\d+&?/, '').replace(/&$/, ''),
            url_info = this.parseUrl(redirect_url),
            url = url_info.path;

        if (typeof url_info.query != 'undefined' && url_info.query.length) {

          // trim off page parameter, whitespace and ? or & characters from end of string
          var query = url_info.query.replace(/(&)?page=\d+/, '');
          var l = query.length,
              extras = '\n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000 ?&';

          for (var i = 0; i < l; i++) {
            if (extras.indexOf(query.charAt(i)) === -1) {
              query = query.substring(i);
              break;
            }
          }

          l = query.length;
          for (var i = l - 1; i >= 0; i--) {
            if (extras.indexOf(query.charAt(i)) === -1) {
              query = query.substring(0, i + 1);
              break;
            }
          }

          if (query.length) {
            this.query = query;
          }

        }

      },

      _setStartEnd: function() {
        this.start = ((this.page - 1) * this.per_page) + 1;
        this.end = this.start + this.per_page - 1;
        if (this.end > this.total) {
          this.end = this.total;
        }
      }

    });

    return Paginator;
  }
);
